"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Warning = _interopRequireDefault(require("@mui/icons-material/Warning"));

var _colors = require("@mui/material/colors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var warningColor = _colors.yellow[100];
var warningText = _colors.brown[400];

var getMessageColor = function getMessageColor(type) {
  switch (type) {
    case 'warning':
    default:
      return warningColor;
  }
};

var Icon = function Icon(props) {
  switch (props.type) {
    case 'warning':
    default:
      return /*#__PURE__*/_react["default"].createElement(_Warning["default"], {
        style: _objectSpread({
          color: warningText
        }, props.style)
      });
  }
};

var Message = function Message(props) {
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    style: _objectSpread({
      padding: '15px',
      marginBottom: '15px',
      fontWeight: 'bold',
      color: warningText,
      fontSize: '18px',
      backgroundColor: getMessageColor(props.type)
    }, props.style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-sm-2",
    style: {
      position: 'initial'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden-xs",
    style: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    type: props.type,
    style: {
      height: '48px',
      width: '48px'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-sm-10"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1"
  }, props.text))));
};

var _default = Message;
exports["default"] = _default;